import Card from "../UI/Card";

const Halloween = () => {
	return (
		<div>
			<Card className={"Card__AltColor App_halloween rotate-scale-up"}>
				<div>🎃</div>
				<div>IT'S HALLOWEEN FOOLS!</div>
				<div>🎃</div>
			</Card>
			<div className="vibrate-1">
				<span>
					👻 👻 👻 👻 👻 👻 👻 👻 👻 👻 👻 👻 👻 👻 👻 👻 👻 👻 👻 👻
					👻 👻 👻 👻 👻 👻 👻 👻 👻 👻 👻 👻 👻 👻 👻 👻 👻 👻 👻 👻
					👻 👻 👻 👻 👻 👻 👻 👻 👻 👻 👻 👻 👻 👻 👻 👻 👻 👻 👻 👻
					👻 👻 👻 👻{" "}
				</span>
			</div>
		</div>
	);
};

export default Halloween;
